module.exports = __webpack_public_path__ + "static/media/elife-news-50x-coins.7df08f16.png";